import { Icon, IconProps } from '@chakra-ui/react';

type Props = IconProps;

export const DashboardIcon = ({ ...rest }: Props) => (
  <Icon viewBox="0 0 24 24" fill="none" width="20px" height="20px" {...rest}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.75 6.75a2 2 0 0 1 2-2h10.5a2 2 0 0 1 2 2v10.5a2 2 0 0 1-2 2H6.75a2 2 0 0 1-2-2V6.75ZM9.75 8.75V19M5 8.25h14"
    />
  </Icon>
);
